import { MdAdd, MdCancel, MdDelete, MdSave } from 'react-icons/md'

import { IconButton } from 'src/components/atoms/IconButton'
import { ParagraphNoSpace } from 'src/components/atoms/Typography'

import { MapCustomControls } from '../MapCustomControls'

export type PolygonMapControlsProps = {
  isAdding: boolean
  hasItemSelected: boolean
  error?: string
  onNewClick: () => void
  onSaveClick: () => void
  onCancelClick: () => void
  onDeleteClick: () => void
}

export const PolygonMapControls = ({
  isAdding,
  hasItemSelected,
  onNewClick,
  onSaveClick,
  onCancelClick,
  onDeleteClick,
  error
}: PolygonMapControlsProps) => {
  return (
    <MapCustomControls position='TOP_RIGHT'>
      <div
        data-testid='poly-map-controls'
        className='flex flex-col gap-2 w-96 items-end'
      >
        <ParagraphNoSpace className='text-sm'>
          <b>Hint:</b> Select the plus symbol to begin drawing a polygon around
          the planting area. Right click any point to remove.
        </ParagraphNoSpace>
        <div className='flex flex-row gap-1'>
          <IconButton
            data-testid='polygon-create-button'
            color='primary-inverted'
            icon={MdAdd}
            ariaLabel='Create'
            disabled={isAdding || hasItemSelected}
            onClick={onNewClick}
          />
          <IconButton
            data-testid='polygon-delete-button'
            color='primary-inverted'
            icon={MdDelete}
            ariaLabel='Delete'
            disabled={!hasItemSelected || isAdding}
            onClick={onDeleteClick}
          />
          <IconButton
            data-testid='polygon-save-button'
            color='primary-inverted'
            icon={MdSave}
            ariaLabel='Save'
            disabled={!isAdding}
            onClick={onSaveClick}
          />
          <IconButton
            data-testid='polygon-cancel-button'
            color='primary-inverted'
            icon={MdCancel}
            ariaLabel='Cancel'
            disabled={!isAdding}
            onClick={onCancelClick}
          />
        </div>
        {error ? <span className='text-red-500'>{error}</span> : null}
      </div>
    </MapCustomControls>
  )
}
